<template>
  <h1 class="section__title animated-title" :class="{'animating': pageReady}">
    <PageTitleContent :isActive="isActive" :titleValue="titleValue"></PageTitleContent>
  </h1>
</template>

<script>
  import { mapGetters } from 'vuex';
  import PageTitleContent from '@/components/PageTitleContent';

  export default {
    name: 'pageTitle',
    props: ['titleValue', 'isActive'],
    components: {
      PageTitleContent,
    },
    computed: mapGetters({
      pageReady: 'pageReady',
    }),
  };
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/PageTitle.vue?25953634